import { nullSafe } from 'src/app/utils';
export function getModifiedNameWithPhone(model: any) {

  const name = [nullSafe(x => model.firstName.trim(), ''),
  nullSafe(x => model.middleName.trim(), ''),
  nullSafe(x => model.lastName.trim(), '')].join(' ').trim();

    const phoneno = [nullSafe(x => model.countryCode.trim(), ''),
    nullSafe(x => model.phoneNumber.trim(), '')].filter(y => y.length > 0).join('-').trim();


    if (name.length > 0) {
        if (phoneno.length > 0) {
            return `(${name}, ${phoneno})`;
        } else {
            return `(${name})`;
        }

    }
    return '';

}

export function getModifiedName(model: any) {

  const name = [nullSafe(x => model.firstName.trim(), ''),
  nullSafe(x => model.middleName.trim(), ''),
  nullSafe(x => model.lastName.trim(), '')].join(' ').trim();

    if (name.length > 0) {
            return `(${name})`;
        }
    
    return '';

}
